// StoreInfoDict.js
// DbdbTap 2024-09-02 16:53:54
import { InputType, TableColumnType } from "../../value/AppConst";
import IsValid from "../../value/IsValid";
import ValueMisc from "../../value/ValueMisc";

/*

    점포구분.........storeTypeCd
    점포코드.........storeId
    점포명...........storeName
    우편번호............zipCd
    주소...............addr
    점포 연락처........officeTelno
    점포 담당자........storeStaffName
    보안실 연락처......secuTelno
    보안 담당자........secuStaffName
    종합사무실 연락처.....totTelno

*/
const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    storeId : {
		id: 'storeId', label: '점포코드',
		type: InputType.text, required: true, toAdd: false, toEdit: true,
		help: '10자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 10)},
	},
    storeTypeCd : {
		id: 'storeTypeCd', label: '점포구분', // select from store_type
		type: InputType.select, required: true, toAdd: true, toEdit: true,
		labelKey:'storeTypeName',
	},
    storeTypeName : { id: 'storeTypeName', label: '점포구분' },
    storeName : {
		id: 'storeName', label: '점포명',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		check: (value) => {return IsValid.string(value, 1, 30)},
	},
    zipCd : {
		id: 'zipCd', label: '우편#',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '7자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 7)},
	},
    addr : {
		id: 'addr', label: '주소',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '100자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 100)},
	},
    officeTelno : {
		id: 'officeTelno', label: '점포 연락처',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '15자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 15)},
	},
    storeStaffName : {
		id: 'storeStaffName', label: '담당자',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '12자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 12)},
	},
    secuTelno : {
		id: 'secuTelno', label: '보안실연락처',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '15자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 15)},
	},
    secuStaffName : {
		id: 'secuStaffName', label: '보안실',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '12자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 12)},
	},
    totTelno : {
		id: 'totTelno', label: '종합사무실연락처',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '15자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 15)},
	},
    ignoreDup: {
        id: 'ignoreDup', label: '동일한 점포이름이 다른 점포에서 사용중이어도 저장',
        type: InputType.checkbox, required: true, toAdd: true, toEdit: true,
    },
    useYn : {
		id: 'useYn', label: '사용여부',
		/* type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '1자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 1)}, */
	},
    fillRateYn : {
		id: 'fillRateYn', label: 'fillRateYn',
		/* type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '1자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 1)}, */
	},
};

const PeopleDict = {
    storeId: Dict.storeId,
    storeName : {id: 'storeName', label: '점포명'},
    zipCd: {id: 'zipCd', label: '우편번호'},
    addr: {id: 'addr', label: '주소'},
    officeTelno: Dict.officeTelno,
    storeStaffName: Dict.storeStaffName,
    secuTelno: Dict.secuTelno,
    secuStaffName: Dict.secuStaffName,
};

const GeoDict = {
    lat : {
		id: 'lat', label: 'lat',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	},
    lon : {
		id: 'lon', label: 'lon',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	},
    xCoord : {
		id: 'xCoord', label: 'xCoord',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	},
    yCoord : {
		id: 'yCoord', label: 'yCoord',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	},
    zoneShape : {
		id: 'zoneShape', label: 'zoneShape',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
	},
    useZone : {
		id: 'useZone', label: 'useZone',
		type: InputType.checkbox, required: true, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	},
};

/**
 * STORE_INFO React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2024-09-02 16:53:54 using DbdbTap
 */
export const StoreInfoDictionary = {
    inputMap: Dict,
    peopleInputMap: PeopleDict,
    errorTitle: {
        Add: '점포 등록 오류',
        Edit: '점포정보 수정 오류',
        Remove: '점포 삭제 오류',
        Get: '점포 조회 오류',
        SetUsage: '점포 사용여부 변경 오류',
    },
    tableProps: {
        tableId: 'storeInfoTable',
        uniqueKey: 'storeId',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            growToFill: true,
            styles: [
                {
                    when: (rec) => rec.useYn === 'N',
                    style: { color: '#555' },
                }
            ]
        },
        columns: [
            //print using getTableColumnOption(c,t,i)
            { id: 'storeId', label: Dict.storeId.label, width: 70, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'storeTypeCd', label: Dict.storeTypeCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'storeTypeName', label: Dict.storeTypeName.label, width: 160, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'storeName', label: Dict.storeName.label, width: 160, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'zipCd', label: Dict.zipCd.label, width: 60, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'addr', label: Dict.addr.label, width: 240, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'officeTelno', label: Dict.officeTelno.label, width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'storeStaffName', label: Dict.storeStaffName.label, width: 70, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'secuTelno', label: Dict.secuTelno.label, width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'secuStaffName', label: Dict.secuStaffName.label, width: 70, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'totTelno', label: Dict.totTelno.label, width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'useYn', label: Dict.useYn.label, width: 70, show: true, option:{align: 'center', print: ValueMisc.printUsage} },
            //{ id: 'fillRateYn', label: Dict.fillRateYn.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'regDate', label: "등록일", width: 90, show: true, option:{align: 'center', print:ValueMisc.printDate} },
            { id: 'regUserName', label: "등록자", width: 80, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            
        ]
    },
};
